
    import '/opt/buildhome/repo/packages/x/components/x-provider/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["x-provider-demo-locale","x-provider-demo-direction","x-provider-demo-theme","x-provider-demo-shortcutkeys"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/x-provider/index.zh-CN.md?type=demo')
};